import React from "react";

import "./status_renderer.less";
import { DraftBadge } from "@src/components/app_layout/components/draft_badge";
import { OutdatedBadge } from "@src/components/outdated_badge";
import Status from "@src/components/status/status";
import { REQUEST_STATUS, ROLES } from "@src/constants";
import {
  AdapterCellRendererProps,
  StatusRendererValue,
} from "@src/types/custom_renderer_types";

interface StatusRendererProps {
  props: AdapterCellRendererProps<StatusRendererValue>;
}

const StatusRenderer: React.FC<StatusRendererProps> = ({ props }) => {
  const {
    status,
    isOutdated = false,
    daysUntilDeletion = null,
    assignedEmployeeFullName = "",
    jointVenturePartner = "",
    isJointVentureRequest = false,
  } = props.adapter(props.data);

  if (status === REQUEST_STATUS.DRAFT) return <DraftBadge />;

  return isOutdated && props.context?.view === ROLES.PROJECT_LEAD ? (
    <OutdatedBadge daysUntilDeletion={daysUntilDeletion} />
  ) : (
    <Status
      status={status}
      assignedEmployeeFullName={assignedEmployeeFullName}
      jointVenturePartner={jointVenturePartner}
      isJointVentureRequest={isJointVentureRequest}
    />
  );
};

export default StatusRenderer;
